import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  printTitle: {
    fontWeight: 600,
    '@media print': {
      '&&': {
        color: 'black',
        fontWeight: 600
      }
    }
  },
  readLabel: {
    padding: '2px',
    color: `${theme.palette.primary.main}`,
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  fieldLabel: {
    padding: '2px',
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  requiredFieldLabel: {
    padding: '2px',
    color: `${theme.palette.error.main}`,
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  statementTitle: {
    margin: '10px',
    padding: '2px',
    fontSize: '1.4rem',
    fontWeight: 'bold',
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  statementReadTitle: {
    padding: '2px',
    fontSize: '1.4rem',
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  statementField: {
    padding: '2px',
    fontSize: '1rem',
    '@media print': {
      '&&': {
        color: 'black'
      }
    }
  },
  defaultColor: {
    color: `${theme.palette.text.notes}`
  },
  required: {
    color: `${theme.palette.error.main}`
  },
  label: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px'
  },
  requiredLabel: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
    color: `${theme.palette.error.main}`
  },
  buttonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '14px',
    marginRight: '10px'
  },
  radioButtonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '12px',
    marginRight: '10px'
  },
  buttonLabel: {
    fontSize: '0.8rem'
  },
  buttonOutlined: {
    padding: '1px'
  },
  readOnly: {
    color: `${theme.palette.text.notes}`,
    '&&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default'
    }
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },
  helperText: {
    color: `${theme.palette.primary.main}`,
    margin: 0,
    marginLeft: 30
  },
  chipRoot: {
    backgroundColor: `${theme.palette.error.main}`,
    color: `${theme.palette.common.white}`,
    height: `22px`
  },
  largeTextField: {
    width: '100%'
  }
}));